import { useTheme } from '@mui/material';
import React, { useState } from 'react';
import { Menu, MenuItem, Sidebar, SubMenu } from 'react-pro-sidebar';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import Dashboard from '../../assets/images/dashboard.png';
// import Logo from '../../assets/images/logo_mini.svg';
import Logo from '../../assets/images/NewLogo.svg';
import Maintenance from '../../assets/images/maintenance.png';
import Option from '../../assets/images/option.png';
import Report from '../../assets/images/report.png';
import { maintenance, 
    options,
 } from '../../utility/constants/usersidebar';
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";


function Userdeptsidebar() {
    const theme = useTheme();
    const [open, setOpen] = useState(undefined);
    const [open2, setOpen2] = useState(undefined);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selectedIndex = useSelector((state) => state.authendicationReducer.selectedIndex)

    const handleMouseEnter = () => {
        setIsCollapsed(false);
    }
    const handleMouseLeave = () => {
        setIsCollapsed(true);
    }
    const handleSubmenuClick = (label) => {
        if (open === label) {
            setOpen(undefined)
        } else {
            setOpen(label)
        }

    }
    const handleSubmenu2Click = (label) => {
        if (open2 === label) {
            setOpen2(undefined)
        } else {
            setOpen2(label)
        }

    }
    const handleNavigation = (path) => {
        navigate(path);
    };
    const handleMenuItemClick = (path, label, submenu) => {
        if(path!=='#'){
        handleNavigation(path)
        dispatch(setSelectedIndex('SET_INDEX_LABEL', label));
        dispatch(setHeaderName('SET_HEADER_NAME', submenu));
        }     
    }
    return (

        <Sidebar
            className='usersidebar'
            collapsed={isCollapsed}
            rootStyles={{
                minHeight: '100vh',
                backgroundColor: theme.palette.primary.main,     //Need to change for dark mode
                border: 'none',
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 1600,

                fontSize: 12,
                '& .ps-sidebar-container': {
                    backgroundColor: 'inherit'
                }
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Link to='#' style={{ display: 'block', textAlign: 'start', padding: '30px 20px', }}><img src={Logo} alt='Logo' /></Link>
            <Menu
                menuItemStyles={{
                    button: ({ level, active, disabled }) => {
                        // only apply styles on first level elements of the tree
                        if (level === 0)
                            return {
                                color: disabled ? '#f5d9ff' : '#FFF',
                            };
                    },
                }}
                rootStyles={{
                    backgroundColor: theme.palette.primary.main,    //Need to change for dark mode
                    height: 'calc(100vh - 114px)',
                    overflow: 'auto',
                    color: '#3B3B3B',
                    '& .ps-menu-button': {
                        height: '36px',
                        '&:not(.ps-disabled,.ps-open):hover': {
                            background: theme.palette.primary.light,
                        },
                        '&.ps-disabled': {
                            backgroundColor: '#9377b4'
                        },
                        '&.ps-open': {
                            backgroundColor: !isCollapsed ? theme.palette.primary.dark : 'transparent'
                        },
                        '& .ps-submenu-expand-icon': {
                            // display: 'none'
                            '& span': {
                                display: isCollapsed ? 'none' : ''
                            }
                        },
                        '& .ps-menu-icon.ps-active:not(.ps-open)': {
                            // backgroundColor: 'rgba(190, 142, 228, 1)'
                            background: theme.palette.primary.light,
                            borderRadius: '4px'
                        },
                        '&.ps-active:not(:hover)': {
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.common.white,
                        }
                    },
                    // submenu styles
                    '& .ps-submenu-root .ps-submenu-content': {
                        backgroundColor: '#f8f3fb',
                        '& .ps-menu-button': {
                            height: '36px',
                            '&:not(.ps-disabled,.ps-open):hover': {
                                // backgroundColor: '#e2bdff36',
                                // backgroundColor: '#E1D4EC',
                                backgroundColor: theme.palette.primary.hover,
                                // color: theme.palette.primary.contrastText,
                            },
                            '&.ps-open': {
                                color: theme.palette.common.white
                            },
                            '&.ps-active:hover': {
                                color: theme.palette.common.white,
                                backgroundColor: theme.palette.primary.light,
                            }
                        }
                    }
                }}
            >
                {/* actual menu starts from here  */}
                <MenuItem icon={<img src={Dashboard} alt='Dashboard' />} onClick={() => handleMenuItemClick('/Userdeptdashboard', 'Dashboard', 'Dashboard')}> User Department Dashboard</MenuItem>
                
                <SubMenu
                    open={open === 'Maintenance'}
                    onClick={() => handleSubmenuClick('Maintenance')}
                    icon={<img src={Maintenance} />} label="Maintenance" >
                    {maintenance.map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Maintenance')}>{data.label}</MenuItem>)}
                </SubMenu>
              
                   
             <SubMenu open={open === 'Options'}
                    onClick={() => handleSubmenuClick('Options')}
                    icon={<img src={Option} alt='Options' />} label="Options">
                    {options.map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Options')}>{data.label}</MenuItem>)}
                </SubMenu>
            </Menu>
        </Sidebar >
    )
}

export default Userdeptsidebar;
